import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import ManualPrinterInput from './ManualPrinterInput';
import PrinterListSelector from './PrinterListSelector';
import styles from './MobilePrinter.css';

interface MobilePrinterContentProps {
  isPrinterConnected: boolean;
  manualPrinterNumber: string;
  handleManualPrinterNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  translationRoot: string;
  inputRootClass: string;
  mobilePrinterListError: string | null;
  mobilePrinterList: string[];
  mobilePrinterListLoading: boolean;
  handlePrinterSelectionFromList: (printer: string) => void;
  selectedPrinterFromList: string;
  connectedPrinterNumber: string;
  mobilePrinterListFeatureEnabled: boolean;
  onSubmit?: () => void;
}

const MobilePrinterContent = forwardRef<HTMLInputElement, MobilePrinterContentProps>(({
  isPrinterConnected,
  manualPrinterNumber,
  handleManualPrinterNumberChange,
  translationRoot,
  inputRootClass,
  mobilePrinterListError,
  mobilePrinterList,
  mobilePrinterListLoading,
  handlePrinterSelectionFromList,
  selectedPrinterFromList,
  connectedPrinterNumber,
  mobilePrinterListFeatureEnabled,
  onSubmit,
}, ref) => {
  const { t } = useTranslation();

  if (isPrinterConnected) {
    return (
      <div>
        {t(`${translationRoot}.CONNECTED_TO`)} <span className={styles.boldText}>{connectedPrinterNumber}</span>
      </div>
    );
  }

  return (
    <>
      <ManualPrinterInput
        ref={ref}
        printerNumber={manualPrinterNumber}
        onPrinterNumberChange={handleManualPrinterNumberChange}
        translationRoot={translationRoot}
        inputRootClass={inputRootClass}
        onSubmit={onSubmit}
      />
      {mobilePrinterListFeatureEnabled && (
        <>
          {/* OR Divider */}
          <div className={styles.orDivider}>
            <span className={styles.orText}>{t(`${translationRoot}.OR_TEXT`)}</span>
          </div>

          <PrinterListSelector
            translationRoot={translationRoot}
            printerList={mobilePrinterList}
            listError={mobilePrinterListError}
            onPrinterSelect={handlePrinterSelectionFromList}
            selectedPrinter={selectedPrinterFromList}
            isMobilePrinterListLoading={mobilePrinterListLoading}
          />
        </>
      )}
    </>
  );
});

MobilePrinterContent.displayName = 'MobilePrinterContent';

export default React.memo(MobilePrinterContent);
